import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "text-bold" }

import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useViewField, { ViewFieldProps } from 'SharedComponents/Fields/composables/useViewField';
import { Dadata } from 'SharedDir/declarations/dadata';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SimpleTextValue' },
  __name: 'AddressValue',
  props: {
    modelValue: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    unit: {}
  },
  emits: ["reveal-history"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;
const value = computed(() => props.modelValue.value?.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _cache[0] || (_cache[0] = _createTextVNode(" :  ")),
    _createElementVNode("span", null, _toDisplayString(value.value), 1)
  ]))
}
}

})